// extracted by mini-css-extract-plugin
module.exports = {"notResponderButton":"discussionButton_notResponderButton__33y2v","alertIcon":"discussionButton_alertIcon__CO3Ei"};